module.exports = __webpack_public_path__ + "static/desktop/img/calendar-3-thumb.03d2cc7d.png";